import Layout from "../../components/Layout";
import React, {useEffect, useState, useCallback} from 'react';
import ApiRoute from "../../helper/api";
import GeneralForm from "../../components/Coupon/general-form";
import AdvanceForm from "../../components/Coupon/advance-form";


function EditCoupon() {

    const [update, setUpdate] = useState(0);
    const [data, setData] = useState(null);

    const [editData,setEditData] = useState({});

    const getData = useCallback(async () => {
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const response = await ApiRoute.coupon.single.fn(params.get('id'),'?model=\\App\\CouponManager\\Model\\CouponRender')
        setData(response.results)
    }, []);

    useEffect(() => {
        getData()
    }, [update, getData]);

    useEffect(() => {
        if (data){
            setEditData({
                title : data.title,
                admin_title : data.admin_title,
                active : data.active,
                code : data.code,
                amount : data.amount,
                type : data.type,
                cost_ceiling : data.cost_ceiling,
                cost_floor : data.cost_floor,
                discount_ceiling : data.discount_ceiling,
                sale_price : data.sale_price,
                start_at : data.start_at,
                end_at : data.end_at,
                categories : data.categories,
                products : data.products,
                limit_use : data.limit_use,
                order_count : data.order_count,
                code_type : data.code_type,
                state : data.state,
                payment_method : data.payment_method,
                api : data.api,
                customers : data?.customers ?? [],
                coordinates : data?.coordinates ?? [],
                variants : data.variants,
                shop_id : data.shop_id,
                _id : data._id
            })
        }
    }, [data]);

    async function handleSubmit() {
        await ApiRoute.coupon.update.fn(editData._id, editData)
        setUpdate(Date.now())
    }

    return (
        <Layout>
            {editData && Object.keys(editData).length > 0 && <div>
                <div>
                    <div className="page-title mb-3"><span className="inline-block bg-white pl-3">ویرایش کد تخفیف</span>
                    </div>

                    <GeneralForm key={editData._id || update} editData={editData}/>

                    <AdvanceForm key={editData._id || update} editData={editData}/>

                </div>
                <div className="flex justify-center">
                    <button onClick={handleSubmit} className="btn-purple">ویرایش کد تخفیف</button>
                </div>
            </div>}
        </Layout>
    )
}

export default EditCoupon